export const NotFound = () => <div className="center size-full">404 Not Found</div>
